import { can, CAPABILITY } from '@aytm/app/stats/page/data-quality-report/lib/tiers'

// The panel's one quarantined figure. A vector toggle recomputes the set, so a viewer who can toggle
// counts the uid set they hold; every tier below counts the producer's aggregate, which is narrowed
// to what that tier may see. Nullish, not truthy: a payload reporting nothing quarantined keeps its
// zero, or the fallback would answer with the whole set and no gate could withhold its control.
export const calcPanelQuarantineCount = (tier, dc = {}) =>
  can(tier, CAPABILITY.SELECT_VECTORS) ? dc.quarantineUIDs?.length || 0 : (dc.quarantineCount ?? 0)

// The same figure over the whole survey. The administrative panel follows the stats-page filter
// while the export file and the run's own account do not, so where the producer sends the
// whole-survey figure it wins; below that tier the two are one set.
export const calcWholeSurveyQuarantineCount = (tier, dc = {}) =>
  dc.wholeSurveyQuarantineCount ?? calcPanelQuarantineCount(tier, dc)
